import { render, staticRenderFns } from "./live-leg.vue?vue&type=template&id=a4dfd3a8&"
import script from "./live-leg.vue?vue&type=script&lang=js&"
export * from "./live-leg.vue?vue&type=script&lang=js&"
import style0 from "./live-leg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "live-leg.vue"
export default component.exports